<template>
  <v-card :loading="loading">
    <v-card-title>
      {{ userName }}
    </v-card-title>
    <v-card-subtitle>
      <div v-if="subscriber && subscriber.status == 'active'">
        {{ planName }} @ ₹
        {{ planAmount }} | Expiry date:
        {{ expiryDate || "NA" }}
      </div>
      <div v-if="subscriber && subscriber.status !== 'active'">
        Subscription status: {{ subscriber.status }}
      </div>
    </v-card-subtitle>
    <v-card-text> </v-card-text>
    <v-divider />
    <v-card-actions>
      <v-btn v-if="subscriber && subscriber.status == 'active'" text @click.stop="showDeleteDialog = true"
        color="primary">
        Unsubscribe
      </v-btn>
      <v-spacer />
      <v-btn text color="primary" @click="editUser">
        <v-icon>{{ icons.view }}</v-icon>
      </v-btn>
      <UnsubscribeDialog :title="dialogConfirmTitle" :visible="showDeleteDialog" @close="showDeleteDialog = false"
        @confirmAction="unsubscribeUser" />
    </v-card-actions>
  </v-card>
</template>
<script>
import { mdiPencil, mdiDelete, mdiEyeCircle } from '@mdi/js'
import UnsubscribeDialog from '@/components/UnsubscribeDialog'
import subPlanApi from '@/api/subPlanApi'
import snackbar from '@/utils/snackbar'
import * as dateFormats from '@/constants/dateFormats'

export default {
  components: {
    UnsubscribeDialog
  },
  props: {
    user: {
      default: null,
      type: Object,
      required: true
    }
  },
  data () {
    return {
      dialogConfirmTitle: 'Are you sure you want to unsubscribe for this user?',
      showDeleteDialog: false,
      loading: false,
      icons: {
        edit: mdiPencil,
        delete: mdiDelete,
        view: mdiEyeCircle
      }
    }
  },

  methods: {
    async unsubscribeUser (cancelImmediately) {
      this.$log.info('unsubscribing user', [cancelImmediately])
      this.loading = true
      try {
        const k = await subPlanApi.unsubscribeUser({
          id: this.user.id,
          cancel_immediately: cancelImmediately
        })
        if (k.data !== undefined) {
          this.$emit('refresh')
          snackbar.show('User unsubscribed successfully', 'success')
        }
      } finally {
        this.loading = false
      }
    },
    editUser () {
      this.$router.push({ path: '/user/edit/' + this.user.id })
    }
  },
  computed: {
    expiryDate () {
      if (this.user !== null && this.user.subscription !== null) {
        return this.$moment(this.user.subscription.end_date).format(
          dateFormats.FRIENDLY_DATE_1
        )
      }
      return null
    },
    planAmount () {
      if (this.subscriber.plan) {
        return this.subscriber.plan.amount / 100
      }
      return 'N/A'
    },
    planName () {
      if (this.subscriber.plan) {
        return this.subscriber.plan.name
      }
      return 'Invalid Plan'
    },
    userName: {
      get () {
        if (this.user.mobile_number !== null) {
          return this.user.mobile_number
        }
        if (this.user.email !== null) {
          return this.user.email
        }
        return ''
      }
    },
    subscriber: {
      get () {
        if (this.user.subscription) {
          return this.user.subscription
        }
        return null
      }
    }
  }
}
</script>
